import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconHeart = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M15.9996 29.0143L13.8905 27.1419C6.39956 20.5177 1.4541 16.1489 1.4541 10.7871C1.4541 6.41826 4.9741 2.9856 9.4541 2.9856C11.985 2.9856 14.4141 4.13455 15.9996 5.95017C17.585 4.13455 20.0141 2.9856 22.545 2.9856C27.025 2.9856 30.545 6.41826 30.545 10.7871C30.545 16.1489 25.5996 20.5177 18.1086 27.1561L15.9996 29.0143Z",
        stroke: "black",
        strokeWidth: 1.5,
        strokeLinejoin: "round"
    }));

export { IconHeart };
